import React from "react";
import { CalendarIcon, SparklesIcon } from "@heroicons/react/24/outline";
import type { MilestonesSkeletonProps } from "../milestonesPhase.types";

export default function MilestonesSkeleton({ className }: MilestonesSkeletonProps) {
  return (
    <div className={`space-y-4 ${className || ""}`}>
      {/* Header */}
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <div className="flex items-center space-x-3">
          <CalendarIcon className="h-5 w-5 text-orange-600" />
          <div>
            <h2 className="text-lg font-semibold text-gray-900">
              Gerando Timeline do Projeto
            </h2>
            <p className="text-sm text-gray-600">
              A IA está analisando seu projeto e criando marcos realistas...
            </p>
          </div>
        </div>
      </div>

      {/* Generation Progress */}
      <div className="bg-gradient-to-r from-orange-50 to-yellow-50 rounded-lg border border-orange-200 p-6">
        <div className="flex items-center space-x-3">
          <div className="flex-shrink-0 p-2 bg-orange-100 rounded-lg">
            <SparklesIcon className="h-5 w-5 text-orange-600 animate-pulse" />
          </div>
          <div className="flex-1">
            <h3 className="text-md font-medium text-gray-900 mb-2">
              IA Gerando Timeline...
            </h3>
            <div className="space-y-2">
              <div className="flex items-center space-x-2 text-sm text-gray-600">
                <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-orange-600"></div>
                <span>Analisando objetivos e solução técnica</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-gray-600">
                <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-orange-600"></div>
                <span>Estimando durações e dependências</span>
              </div>
              <div className="flex items-center space-x-2 text-sm text-gray-600">
                <div className="animate-spin rounded-full h-3 w-3 border-b-2 border-orange-600"></div>
                <span>Identificando caminho crítico</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Skeleton Milestones */}
      <div className="bg-white rounded-lg border border-gray-200 p-4">
        <div className="mb-4">
          <div className="h-4 bg-gray-200 rounded w-1/4 animate-pulse"></div>
        </div>
        
        <div className="space-y-3">
          {[1, 2, 3, 4].map((i) => (
            <div
              key={i}
              className="bg-gray-50 rounded-lg p-4 border-l-4 border-gray-200"
            >
              <div className="flex items-start justify-between">
                <div className="flex-1">
                  <div className="flex items-center space-x-2 mb-2">
                    <div className="h-5 bg-orange-100 rounded-full w-16 animate-pulse"></div>
                    <div className="h-5 bg-gray-200 rounded-full w-20 animate-pulse"></div>
                    <div className="h-5 bg-gray-200 rounded-full w-12 animate-pulse"></div>
                  </div>
                  <div className="h-5 bg-gray-200 rounded w-2/3 mb-2 animate-pulse"></div>
                  <div className="h-4 bg-gray-200 rounded w-full mb-2 animate-pulse"></div>
                  <div className="h-4 bg-gray-200 rounded w-3/4 animate-pulse"></div>
                  <div className="flex items-center space-x-4 mt-2">
                    <div className="h-3 bg-gray-200 rounded w-16 animate-pulse"></div>
                    <div className="h-3 bg-gray-200 rounded w-20 animate-pulse"></div>
                    <div className="h-3 bg-gray-200 rounded w-24 animate-pulse"></div>
                  </div>
                </div>
                <div className="h-8 bg-gray-200 rounded w-16 animate-pulse"></div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Loading Message */}
      <div className="text-center py-6">
        <div className="flex items-center justify-center space-x-2 text-sm text-gray-500">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-orange-600"></div>
          <span>Gerando timeline personalizada para seu projeto...</span>
        </div>
      </div>
    </div>
  );
}